import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initializeAnalytics } from './core/analytics/googleAnalytics';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

initializeAnalytics();

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
